module.exports = __webpack_public_path__ + "img/DMIDCROMS_BrandGraphic_Home.7d1e5642.png";